// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"MX-z","loadingMedia":"NX-z","reviewsImagesAndVideos":"OX-z","limitHeight":"PX-z"};